export default "__VITE_ASSET__rhYtyHmI__"